import { Markdown as MD } from '@features/markdown/components/Markdown';
import { useMediaQuery } from 'react-responsive';
import { Breakpoints } from '@settings';
import classNames from 'classnames';
import cx from '@utils/cx.util';

const Content = ({ attributes }) => {
  const isMobView = useMediaQuery({ maxWidth: Breakpoints.LG });

  const image = isMobView && attributes.image?.mobile || attributes.image?.desktop;
  console.log({ attributes, image })

  return (
    <div className={classNames('tw-flex tw-flex-col tw-items-center tw-justify-between tw-gap-6 lg:tw-flex-row', {
      'justify-content-center': attributes.align === 'center',
    })}>
      {image && <div
        className={classNames('tw-order-1', {
          'lg:tw-order-2': attributes.imagePosition === 'right',
        })}>
        <img
          src={image.url}
          alt={attributes.image.alt}
          className='tw-max-h-full tw-w-full tw-max-w-[696px] tw-rounded-button'
        />
      </div>}
      <div
        className={cx(
          'tw-order-2 tw-max-w-[696px] lg:tw-px-5 xl:tw-px-20',
          {
            'tw-max-w-[660px]': !image,
            'lg:tw-order-1': attributes.imagePosition === 'right',
            'tw-text-center': attributes.align === 'center',
            'tw-text-right': attributes.align === 'right',
          },
          attributes.cssClass
        )}>
        <p
          className={classNames('tw-text-left tw-font-subtitle tw-text-2xl tw-font-bold tw-leading-tight tw-text-black lg:tw-text-[40px]', {
            'tw-text-center': attributes.align === 'center',
            'tw-text-right': attributes.align === 'right',
          })}>
          {attributes.title}
        </p>
        <p className='tw-mb-0 tw-font-body tw-text-sm tw-text-black lg:tw-text-base'><MD source={attributes.text} /></p>
      </div>
    </div>
  );
};

export default Content;
